module.exports = __webpack_public_path__ + "img/acebook.c18c68e6.svg";